import React from "react";

export default props => {
  return (
    <button className="btn btn-transparent-black" onClick={props.onClick}>
      Back
    </button>
  );
};



// WEBPACK FOOTER //
// ./src/modules/ContactForm/components/BackButton.js